import OptionToggle from '~/components/OptionToggle';
import React from 'react';

const QuantityOptionSettings = ({ settings, setSettings }) => {
    return (
        <>
            <OptionToggle
                className="mt-4"
                value={settings?.hideQuantity}
                onChange={value =>
                    setSettings({
                        ...settings,
                        hideQuantity: value,
                    })
                }
                title="Hide Quantity"
                description="Don't allow clients to book multiple spots for classes/group events"
            />

            {!settings?.hideQuantity && (
                <OptionToggle
                    className="mt-4"
                    value={settings?.requireExplicitQuantity}
                    onChange={value =>
                        setSettings({
                            ...settings,
                            requireExplicitQuantity: value,
                        })
                    }
                    title="Require Clients Pick Quantity"
                    description="Default to a quantity of 0 instead of 1 so clients must pick a quantity before seeing times"
                />
            )}
        </>
    );
};

export default QuantityOptionSettings;
